import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Spin } from 'antd';
import { Stepper } from 'antd-mobile';
import Format from '../../utils/format';

@inject(
    'templateStore',
    'amenityStore',
    'loginStore',
    'webSettingStore'
)
@observer
class AmenityTabPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }
    }

    // ON CHANGE

    amenityItemQtyOnChange = (taskId, value) => {
        if (value !== '') {
            if (this.isNumber(value)) {
                this.props.amenityStore.setAmenityItemQty(taskId, value);
            } else {
                this.props.amenityStore.setAmenityItemQty(taskId, 0);
            }
        }
    }

    isNumber = (n) => {
        return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    }

    // ON CLICK

    itemOnClick = (taskId) => {
        this.props.amenityStore.getAmenitiesByTaskId(taskId);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const {
            amenityTabLoading
        } = this.props.amenityStore;

        const items = this.props.items;

        let previousGroup = '';
        let currentGroup = '';
        let showGroup = false;

        const { data: webSettting } = this.props.webSettingStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        {
                                            items === null
                                                ?
                                                <Row className='stm-item-notfound-container' style={{ minHeight: document.documentElement.clientHeight - 220 }}>
                                                    <Col
                                                        span={24}
                                                        className='stm-item-notfound'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <span>{webSettting.noDataFoundText}</span>
                                                    </Col>
                                                </Row>
                                                :
                                                <React.Fragment>
                                                    {
                                                        items.length === 0
                                                            ?
                                                            <Row className='stm-item-notfound-container' style={{ minHeight: document.documentElement.clientHeight - 220 }}>
                                                                <Col
                                                                    span={24}
                                                                    className='stm-item-notfound'
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                        color: activeTemplate.templateSetting.text.color,
                                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                    }}
                                                                >
                                                                    <span>{webSettting.noDataFoundText}</span>
                                                                </Col>
                                                            </Row>
                                                            :
                                                            <Spin size='small' spinning={amenityTabLoading}>
                                                                <Row className='stm-margin-bottom-10 stm-background-white' style={{ minHeight: document.documentElement.clientHeight - 220 }}>
                                                                    <Col span={1} />
                                                                    <Col span={22}>
                                                                        {
                                                                            items.map(item => {
                                                                                currentGroup = item.subCategoryName;

                                                                                if (currentGroup !== previousGroup) {
                                                                                    showGroup = true;
                                                                                } else {
                                                                                    showGroup = false;
                                                                                }

                                                                                previousGroup = item.subCategoryName;

                                                                                return (
                                                                                    <React.Fragment key={item.taskId}>
                                                                                        {
                                                                                            showGroup ?
                                                                                                (
                                                                                                    <Row>
                                                                                                        <Col
                                                                                                            span={24}
                                                                                                            className='stm-group-item'
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.subCategoryName !== '' ? item.subCategoryName.toUpperCase() : item.categoryName.toUpperCase()}
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                )
                                                                                                :
                                                                                                null
                                                                                        }
                                                                                        <Row className='stm-item-container' key={item.taskId}>
                                                                                            {/* <Col span={4} className='stm-item-image-container'>
                                                                                        {
                                                                                            item.imageUrl === ''
                                                                                                ?
                                                                                                <img className='stm-item-image' src={menu.imageUrl} alt={item.taskName} onClick={() => this.itemOnClick(item.taskId)} />
                                                                                                :
                                                                                                <img className='stm-item-image' src={item.imageUrl} alt={item.taskName} onClick={() => this.itemOnClick(item.taskId)} />
                                                                                        }
                                                                                    </Col> */}
                                                                                            <Col span={17} className='stm-item-desc' onClick={() => this.itemOnClick(item.taskId)}>
                                                                                                <Row>
                                                                                                    <Col
                                                                                                        span={24}
                                                                                                        className='stm-item-desc-name'
                                                                                                        style={{
                                                                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                            color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`
                                                                                                        }}
                                                                                                    >
                                                                                                        {item.taskName}
                                                                                                    </Col>
                                                                                                    <Col
                                                                                                        span={24}
                                                                                                        className='stm-item-desc-price'
                                                                                                        style={{
                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            item.price === 0
                                                                                                                ?
                                                                                                                null
                                                                                                                :
                                                                                                                <span>{webSettting.currencyCode} {Format.Currency(item.price)}</span>
                                                                                                        }
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                            <Col span={7} className='stm-item-amount'>
                                                                                                {
                                                                                                    (item.minimumStock > 0 && item.total <= 0) || (!item.isAvailable)
                                                                                                        ?
                                                                                                        <div
                                                                                                            className='stm-padding-top-8'
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                color: activeTemplate.templateSetting.buttonItem.color
                                                                                                            }}
                                                                                                        >
                                                                                                            <span>{webSettting.notAvailableText}</span>
                                                                                                        </div>
                                                                                                        :
                                                                                                        <Stepper
                                                                                                            style={{ width: '100%', minWidth: '100px' }}
                                                                                                            showNumber
                                                                                                            defaultValue={0}
                                                                                                            max={item.requestLimit < item.total ? item.requestLimit : item.total}
                                                                                                            min={0}
                                                                                                            value={item.orderQuantity}
                                                                                                            onChange={(value) => this.amenityItemQtyOnChange(item.taskId, value)}
                                                                                                        />
                                                                                                }
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </React.Fragment>
                                                                                )
                                                                            })}
                                                                    </Col>
                                                                    <Col span={1} />
                                                                </Row>
                                                            </Spin>
                                                    }
                                                </React.Fragment>
                                        }
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default AmenityTabPage;